<template>
  <v-dialog 
    v-model="value" 
    max-width="500"
    persistent
  >
    <v-form
      @submit.prevent="submit()"
      ref="form"
      :disabled="isLoading"
    >
      <v-card>
        <v-card-title>
          {{ $t('meter.full_meter') }} / {{ $t('meter.change_meter') }}
        </v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="formData.isExceed"
            :label="`${$t('meter.full_meter')}`"
            @change="formData.isExceed && formData.isChanged ? formData.isChanged = false : ''"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="formData.isChanged"
            :label="`${$t('meter.change_meter')}`"
            @change="formData.isExceed && formData.isChanged ? formData.isExceed = false : ''"
            hide-details
          ></v-checkbox>
          <div class="mt-6">
            <template v-if="formData.isExceed">
              <span><b>{{ $t('validate.please_select_max_water_meter') }}</b></span>
              <v-text-field
                v-model="formData.unitLimit"
                solo
                dense
                class="input-center mt-1"
                :append-outer-icon="'mdi-plus'"
                :prepend-icon="'mdi-minus'"
                @click:append-outer="changeUnitLimit('add')"
                @click:prepend="changeUnitLimit('minus')"
              ></v-text-field>
            </template>
            <template v-if="formData.isChanged">
              <span><b>{{ $t('validate.please_input_last_meter_reading') }}<u>{{ $t('meter.old_meter') }}</u></b></span>
              <v-currency-field
                v-model="formData.oldUnit"
                solo
                dense
                class="input-center input-disable-appearance mt-1"
                :rules="[rules.required]"
              />
              <span><b>{{ $t('validate.please_input_last_meter_reading') }}<u>{{ $t('meter.new_meter') }}</u></b></span>
              <v-currency-field
                v-model="formData.newUnit"
                solo
                dense
                class="input-center input-disable-appearance mt-1"
                :rules="[rules.required]"
              />
            </template>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            elevation="0"
            @click="$emit('input', false)"
            >{{ $t('close') }}</v-btn
          >
          <v-btn
            color="primary"
            elevation="0"
            type="submit"
            :disabled="isLoading"
            >{{ $t('confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value(){
      if(this.data){
        this.formData = {
          isExceed: this.data.isExceed || false,
          isChanged: this.data.isChanged || false,
          unitLimit: this.data.unitLimit || 9999,
          oldUnit: this.data.oldUnit || 0,
          newUnit: this.data.newUnit || 0
        }
      }else{
        this.formData = {
          isExceed: false,
          isChanged: false,
          unitLimit: 9999,
          oldUnit: 0,
          newUnit: 0
        }
      }
    }
  },
  data() {
    return {
      isLoading: false,
      formData: {
        isExceed: false,
        isChanged: false,
        unitLimit: 9999,
        oldUnit: 0,
        newUnit: 0
      },
      rules: {
        required: (value) => !!value || value == 0 || this.$t('validate.please_input_data'),
      },
    };
  },
  methods: {
    changeUnitLimit(type){
      if(type == 'add'){
        this.formData.unitLimit = ((this.formData.unitLimit + 1) * 10) -1
      }else{
        this.formData.unitLimit = ((this.formData.unitLimit + 1) / 10) -1
      }
    },
    submit(){
      if (this.$refs.form.validate()) {
        let data = null
        if(this.formData.isExceed){
          data = {
            isExceed: true,
            unitLimit: parseInt(this.formData.unitLimit)
          }
        }else if(this.formData.isChanged){
          data = {
            isChanged: true,
            oldUnit: parseFloat(this.formData.oldUnit),
            newUnit: parseFloat(this.formData.newUnit)
          }
        }
        this.$emit("onSuccess", data)
        this.$emit("input", false)
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
